import * as t from 'io-ts';
export var Int8 = t.brand(t.string, function (s) { return /^[0-9a-f]{16}$/.test(s); }, 'Int8');
